export default "__VITE_ASSET__U84fGMnx__"